import { create } from "zustand";
import { type KlusModel } from "../models/KlusModel.ts";

type KlussenState = {
  klussen: KlusModel[];
  setKlussen: (res: KlusModel[] | ((prev: KlusModel[]) => KlusModel[])) => void;
  updateKlussen: (klussen: KlusModel[]) => void;
};

export const useKlussenStore = create<KlussenState>((set) => ({
  klussen: [],
  setKlussen: (res) =>
    set((state) => {
      const newKlussen = typeof res === "function" ? res(state.klussen) : res;
      return { klussen: newKlussen };
    }),
  updateKlussen: (updatedKlussen) =>
    set((state) => {
      const updatedMap = new Map(updatedKlussen.map((u) => [u.id, u]));

      const newKlussen = state.klussen.map((k) => updatedMap.get(k.id) ?? k);
      return { klussen: newKlussen };
    }),
}));
